// frontend/src/socket.js
import { io } from "socket.io-client";

const API_URL = "";

// Get JWT from localStorage
const getToken = () => {
  try {
    const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
    return userInfo.token || null;
  } catch {
    return null;
  }
};

const socket = io(API_URL, {
  path: "/socket.io",
  // ⚠ polling ก่อนเสมอ (ค่าตั้งต้นของ socket.io) — 23 ต.ค. 69
  //   เดิม ["websocket", "polling"]: ทางเชื่อมผ่าน NAS ไม่ส่งต่อ websocket → ค้างจน connect_error: timeout
  //   ทุกครั้ง socket ไม่เคยต่อติดบนเว็บจริง (แชทสด แจ้งเตือน ใครออนไลน์ ใช้ไม่ได้) · polling ต่อติดทันที แล้วค่อยอัปเกรดเองถ้าทำได้
  transports: ["polling", "websocket"],
  withCredentials: true,
  autoConnect: false, // We'll connect manually after we have a token
  auth: { token: getToken() },
});

// Auto-connect when user logs in
// 16 ต.ค. 69 — ตอนล็อกอินหลังบ้านเก็บ token ไว้ในคุกกี้ jwt (httpOnly) อย่างเดียว ไม่ส่งมาใน userInfo
//   เดิมเชื่อมต่อเฉพาะตอนมี token → socket ไม่เคยต่อเลย แชท/แจ้งเตือนต้องรอดึงเองเป็นรอบ (ผู้ใช้: "ข้อความที่ AI ตอบไม่แสดงทันที ต้องรีเฟรช")
//   ตอนนี้ต่อทุกครั้งที่ล็อกอิน — หลังบ้าน (protectSocket) อ่านคุกกี้ jwt จาก handshake ได้อยู่แล้ว
export const connectSocket = () => {
  const token = getToken();
  socket.auth = token ? { token } : {};
  if (!socket.connected) socket.connect();
};

export const disconnectSocket = () => {
  if (socket.connected) {
    socket.disconnect();
    console.log("[socket] disconnected");
  }
};

export default socket;
